










































import { defineComponent, ref } from "@vue/composition-api";
import providers from "@/lib/api";
import { UploadVaultFile } from "@/types";
import BaseButton from "@/components/BaseButton";
import InfiniteScroll from "@/components/InfiniteScroll";
import VaultFilesList from "../VaultFilesList";

export default defineComponent({
  name: "VaultManageView",
  components: { VaultFilesList, InfiniteScroll, BaseButton },
  props: {
    vaultFiles: { type: Array as () => UploadVaultFile[], required: true },
    scroll: { type: Boolean },
  },
  setup(props, { emit }) {
    const loading = ref(false);

    const onSubmit = async (files: UploadVaultFile[]) => {
      const categoryId = props.vaultFiles[0].categoryIds[0]; // todo: get category from prop
      const ids = files.map(i => i.id);

      try {
        loading.value = true;
        const response = await providers.VaultsProvider.deleteFileFromCategory({ data: { ids, categoryId } });
        if (response) {
          emit("deleteFilesFromCategory", files);
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      loading,
      onSubmit,
    };
  },
});
